import { Option } from 'shared/interface/globalInterface';

export type Props = {
  variant?: string;
  options: Option[];
  name: any;
  onSelected: any;
  disabled: boolean;
  selected: {
    value: string | undefined;
    label: string | undefined;
  };
  isRequired?: boolean;
  inline?: boolean;
  tight?: boolean;
  placeholderText?: string;
  inputText?: string;
  noOptionsText?: string;
  searchable?: boolean;
  handleBlur?: () => void;
  showError?: boolean;
  tooltip?: string;
};

export type FilteredOptions = Option[];

export enum SELECT_MODES {
  FIXED = 'fixed',
  SEARCH = 'search',
}
